<template>
    <Modal
        v-model="props.isShowModel"
        :closable="false"
        loading
        :mask-closable="false"
        width="720"
        :fullscreen="mobileDevice"
        class="first-model">
        <template #header>
            <div></div>
        </template>
        <div class="content">
            <div class="title-box">
                <div class="m-title">Welcome aboard SlidesOrator！</div>
                <div class="s-title">
                    Congratulations!🎉
                </div>
                <div class="s-title">
                    🥳You've got <span> 300 Credits！</span>
                </div>
            </div>
            <div class="center">
                <div
                    class="item"
                    :class="active == 1 ? 'active' : ''"
                    @click="change(1)">
                    <div class="text-box">
                        <img
                            src="@/assets/first/icon2.png"
                            alt=""
                            class="item-icon" />
                     
                        Start to prepare your first speech.
                    </div>
                    
                    <div class="y-btn">Start</div>
                  
                </div>
                <div
                    class="item"
                    :class="active == 2 ? 'active' : ''"
                    @click="change(2)">
                    <div class="text-box">
                        <img
                            src="@/assets/first/icon1.png"
                            alt=""
                            class="item-icon" />
                      
                            Get Full Features
                    </div>
                    <div class="y-btn ok">Upgrade</div>
                   
                </div>
            </div>
        </div>
        <template #footer>
            <div class="footer-btn"></div>
        </template>
    </Modal>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { useMixinMobileDevice } from "@/mixins/mobileDevice";
const { mobileDevice, Orientation } = useMixinMobileDevice();
import { useRoute, useRouter } from "vue-router";
import {guideSave} from '@/api'
import { useStore } from "vuex";
const store = useStore();
const versionName = computed(() => store.state.app.versionName);
const props = defineProps({
    isShowModel: Boolean,
});
const emits = defineEmits(["change", "close"]);
const active = ref(1); //1 创建文档   2--升级
const router = useRouter();
const change = (num) => {
    active.value = num;
    save()
    switch (num) {
        case 1:
            emits("change");
            break;
        case 2:
            emits("close");
            router.push('/price')
            break;
        default:
            break;
    }
};

const save = () =>{
    console.log(versionName.value)
    guideSave({
        guideComplete: 1,
        versionName:  versionName.value
    }).then((res)=>{
        console.log(res)
    })
}

</script>

<style lang="less">
.first-model {
    .ivu-modal-content {
        border-radius: 20px !important;
        width: 720px;
        height:456px;
    }
    &.ivu-modal-fullscreen {
        width: 90% !important;
        left: 50% !important;
        top: 50% !important;
        transform: translate(-50%, -50%) !important;
        .ivu-modal-content {
            border-radius: 20px !important;
            height: 330px;
        }
    }
}
</style>
<style lang="less" scoped>
.first-model {
    .content {
        padding: 0 26px;
        position: relative;
        .close {
            position: absolute;
            top: -30px;
            right: 0px;
            width: 32px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 4px 4px 4px 4px;
            cursor: pointer;

            &:hover {
                background: rgba(239, 239, 239, 1);
            }

            img {
                width: 16px;
                height: 16px;
            }
        }

        .title-box {
            text-align: center;
            .m-title {
                font-size: 24px;
                font-weight: 500;
                color: rgba(49, 48, 46, 0.60);
            }
            .s-title {
                font-size: 36px;
                color: #31302E;
                font-weight: 600;
                span {
                    color: #4945ff;
                }
            }
        }

        .center {
            display: flex;
            justify-content: center;
            flex-direction: column;
            padding: 50px 60px;
            .item {
                // width: 100%;
                height: 64px;
                margin-bottom: 12px;
                padding: 24px;
                border-radius: 8px;
                cursor: pointer;
                background: rgba(244, 244, 246, 1);
                display: flex;
                align-items: center;
                justify-content: space-between;
                .arrow-icon {
                    width: 24px;
                    height: 24px;
                }
              
                .text-box {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #31302e;
                    font-size: 16px;
                    font-weight: 400;
                    .item-icon {
                        width: 16px;
                        height: 16px;
                        margin-right: 6px;
                    }
                
                }


                &:hover {
                    background: rgba(73, 69, 255, 0.10);
                   
                }

                .y-btn {
                    width: 88px;
                    height: 32px;
                    border-radius: 8px;
                    color: rgba(73, 69, 255, 1);
                    font-size: 14px;
                    font-weight: 600;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    background-color: #fff;
                    &.ok {
                        background:rgba(73, 69, 255, 1);
                        color: #fff;
                    }
                }
            }
        }
    }

    .footer-btn {
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
        padding-right: 20px;
        .y-btn {
            // width: 80px;
            padding: 0 24px;
            line-height: 40px;
            text-align: center;
            height: 40px;
            font-weight: 500;
            border-radius: 8px 8px 8px 8px;
            font-size: 14px;
            margin-left: 14px;
            cursor: pointer;
            background: #4945ff;
            color: #fff;

            &:hover {
                background: rgba(104, 100, 255, 1);
            }
        }
    }

    &.ivu-modal-fullscreen {
        .content {
            padding: 0;
            position: static;
            margin-top: -20px;
            .title-box {
                text-align: center;
                .m-title {
                    font-size: 20px;
                    font-weight: 500;
                    color: #31302eff;
                }
                .s-title {
                    font-size: 12px;
                    color: #31302e99;
                    font-size: 400;
                }
            }

            .center {
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding-top: 14px;
                .item {
                    width: 100%;
                    height: 135px;
                    margin: 10px 0 10px;
                    padding: 14px;
                    border-radius: 8px;
                    cursor: pointer;
                    background: #f4f4ffff;
                    display: flex;
                    .item-icon {
                        width: 52px;
                        height: 52px;
                        margin-right: 10px;
                    }
                    .text-box {
                        .m-text {
                            font-size: 20px;
                            font-weight: 500;
                            margin: 10px 0;
                            color: #31302eff;
                        }
                        .s-text {
                            font-size: 12px;
                            color: #31302eff;
                        }
                    }
                    &.active {
                        background: #4945ffff;
                        .m-text {
                            color: #fff;
                        }
                        .s-text {
                            color: #fff;
                        }
                    }
                }
            }
        }

        .footer-btn {
            display: flex;
            justify-content: center;
            margin-bottom: 10px;
            padding-right: 20px;
            .y-btn {
                // width: 80px;
                padding: 0 24px;
                line-height: 40px;
                text-align: center;
                height: 40px;
                font-weight: 500;
                border-radius: 8px 8px 8px 8px;
                font-size: 14px;
                margin-left: 14px;
                cursor: pointer;
                background: #4945ff;
                color: #fff;

                &:hover {
                    background: rgba(104, 100, 255, 1);
                }
            }
        }
    }
}
</style>
